export const initGraphs = async () => {
  const containers = document.querySelectorAll('[data-tc-graph]')
  if (!containers.length) return

  // Lazy-load the graph implementation (pulls in d3-force) only when a
  // [data-tc-graph] element is on the page.
  const [TerenGraph] = await Promise.all([
    import(/* webpackChunkName: "teren-graph" */ '@/cms/js/teren-graph'),
  ])

  containers.forEach((el) => {
    const dataId = el.dataset.tcGraphData
    const dataEl = dataId ? document.getElementById(dataId) : null
    const data = dataEl
      ? JSON.parse(dataEl.textContent)
      : { nodes: [], edges: [], counts: {} }
    TerenGraph.initGraph({ el, data })
  })
}
